import { FactoryProvider } from '@angular/core';
import { AgSharedConfig, Settings } from '@mri-platform/shared/core';

export const AgSharedConfigProvider: FactoryProvider = {
  provide: AgSharedConfig,
  useFactory: (settings: Settings) => new AgSharedConfig({ ...settings.agShared, interceptNavigation: true }),
  deps: [Settings]
};
